import React from 'react';
import { CheckIcon } from 'lucide-react';
import type { AreaId } from '../../types/pulse';
import { areas } from '../../data/pulse';
interface RankCueProps {
  /** One slot per rank — index 0 is #1. */
  value: (AreaId | null)[];
  onChange: (next: (AreaId | null)[]) => void;
}
const RANKS = [1, 2, 3];
export function RankCue({
  value,
  onChange
}: RankCueProps) {
  const setRank = (area: AreaId, rank: number) => {
    const next = [...value];
    const slot = rank - 1;
    const currentSlot = next.indexOf(area);

    // Ranks already used by another area are blocked, so this only ever
    // assigns a free rank or clears the area's own one.
    if (currentSlot === slot) {
      next[slot] = null;
    } else {
      if (currentSlot >= 0) next[currentSlot] = null;
      next[slot] = area;
    }
    onChange(next);
  };
  return <div className="flex flex-col gap-2.5" data-id="element-189" data-mp="1d7mrr562mi0o">
      {areas.map(area => {
      const rank = value.indexOf(area.id);
      const ranked = rank >= 0;
      return <div key={area.id} className={`rounded-xl border px-4 py-3.5 transition-colors duration-150 ${ranked ? 'border-blue bg-blue/[0.06]' : 'border-line bg-paper'}`} data-id="element-190" data-mp="kxye3m0mqwe">
            <p className="text-[13px] font-semibold leading-snug text-navy" data-id="element-191" data-mp="9fm57y78ognb">{area.label}</p>
            <p className="mt-1 text-[11.5px] leading-snug text-mut" data-id="element-192" data-mp="4lrlwvvjq3or">{area.blurb}</p>

            <div className="mt-3 flex gap-2" role="group" aria-label={`Rank ${area.label} from 1 to 3`} data-id="element-193" data-mp="jb5y0bqiaz7u">
              {RANKS.map(n => {
            const holder = value[n - 1];
            const isMine = holder === area.id;
            const taken = holder !== null && !isMine;
            return <button key={n} type="button" onClick={() => setRank(area.id, n)} disabled={taken} aria-pressed={isMine} aria-label={taken ? `Rank ${n} already given to another area` : `${area.label}: rank ${n}`} className={`flex h-10 flex-1 items-center justify-center gap-1.5 rounded-xl border font-display text-[15px] font-bold tabular-nums transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue ${isMine ? 'border-blue bg-blue text-paper' : taken ? 'cursor-not-allowed border-line bg-line/40 text-mut/50' : 'border-grass/50 bg-grass/[0.08] text-grass hover:border-grass hover:bg-grass/15'}`} data-id="element-194" data-mp="2u3qmecqc03dx">
                    {n}
                    {isMine && <CheckIcon className="h-3 w-3" aria-hidden="true" data-id="element-195" data-mp="1vn2r3z07xuo2" />}
                  </button>;
          })}
            </div>
          </div>;
    })}

      {value.some(v => v !== null) && <button type="button" onClick={() => onChange([null, null, null])} className="self-start text-[11px] text-mut underline underline-offset-2 transition-colors duration-150 hover:text-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-blue" data-id="element-196" data-mp="3g6ewms86jtms">
          Clear ranking
        </button>}
    </div>;
}